import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LandingComponent  } from './modules/landing/landing.component';
import { MainComponent } from './modules/main/main.component';
import { AccountStatusComponent } from './modules/account-status/account-status.component';
import { AccountHistoryComponent } from './modules/account-history/account-history.component';
import { EdocumentsComponent } from './modules/edocuments/edocuments.component';
import { ProfileComponent } from './modules/profile/profile.component';
import { EsignComponent } from '@app/modules/esign/esign.component';
import { DepositoryConfirmationComponent } from "@app/modules/depository-confirmation/depository-confirmation.component";
import { SummaryComponent } from './modules/summary/summary.component';
import { LoginComponent } from './modules/login/login.component';
import { SiteAgreementComponent } from '@app/modules/site-agreement/site-agreement.component';
import { AuthorizationGuard } from './guards/authorization.guard';


const routes: Routes = [
  { path: '', redirectTo: 'landing', pathMatch: 'full' },
  { path: 'landing', component: LandingComponent, data: { animation: 'Landing' }, canActivate: [AuthorizationGuard],// Tied with the main router-outlet
    children: [
      { path: '', component: LoginComponent, outlet: "landing-screen-outlet", pathMatch: 'full'}, // Tied with a named outlet
      { path: 'login', component: LoginComponent, outlet: "landing-screen-outlet" },
      
    ]
  },
  {
    path: 'main', component: MainComponent, data: { animation: 'Main' }, canActivate: [AuthorizationGuard],
    children: [
      { path: '', component: SummaryComponent, data: { animation: 'Summary' } },
      { path: 'summary', component: SummaryComponent, data: { animation: 'Summary' } },
      { path: 'account-status', component: AccountStatusComponent, data: { animation: 'AccountStatus' } },
      { path: 'account-history', component: AccountHistoryComponent, data: { animation: 'AccountHistory' } },
      { path: 'edocuments', component: EdocumentsComponent, data: { animation: 'EDocuments' } },
      { path: 'esign', component: EsignComponent, data: { animation: 'ESign' } },
      { path: 'depository-confirmation', component: DepositoryConfirmationComponent, data: { animation: 'DepositoryConfirmation' } },
      { path: 'profile', component: ProfileComponent, data: { animation: 'Profile' } }  
    ],
  },  
  { path: 'agreement', component: SiteAgreementComponent, data: { animation: 'Agreement' }, canActivate: [AuthorizationGuard] },
  // The wildcard means that the URL doesn't match any path, so redirect back to the Landing component.
  { path: '**', redirectTo: 'landing' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,
      // { enableTracing: true } // <-- debugging purposes only
  )],
  exports: [RouterModule]
})
export class AppRoutingModule { }
